import { createStore } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistCombineReducers } from 'redux-persist';

import reducers from './reducers';

const config = {
  key: 'root',
  storage,
};

const reducer = persistCombineReducers(config, reducers);

export default createStore(reducer);



// WEBPACK FOOTER //
// ./src/store.js